import { render, staticRenderFns } from "./Ocorrencias.vue?vue&type=template&id=55a5562e&scoped=true&"
import script from "./Ocorrencias.vue?vue&type=script&lang=js&"
export * from "./Ocorrencias.vue?vue&type=script&lang=js&"
import style0 from "./Ocorrencias.vue?vue&type=style&index=0&id=55a5562e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a5562e",
  null
  
)

export default component.exports